/**
 * Dekstop menu
 * - Add grace period for mouseouts
 */

 let state = document.querySelector('.js-state');
 let menuActive = false;
 let closeMenuTimeout = null;
 let changeMenuTimeout = null;
 let nextMenu = null;
 let currentActiveMenu = null;

 let womens_size_map = {
  'UK 2 EU 35': 'US 4',
  'UK 3 EU 36': 'US 5',
  'UK 4 EU 37': 'US 6',
  'UK 5 EU 38': 'US 7',
  'UK 6 EU 39': 'US 8',
  'UK 7 EU 40': 'US 9',
  'UK 7.5 EU 41': 'US 9.5',
  'UK 8 EU 42': 'US 10',
  'UK 9 EU 43': 'US 11',
  'UK 10 EU 44': 'US 12',
  'UK 3 - 6' : 'US 5 - 8',
  'UK 7 - 9' : 'US 9 - 11',
  'UK 8 EU 36' : 'US 4',
  'UK 10 EU 38' : 'US 6',
  'UK 12 EU 40' : 'US 8',
  'UK 14 EU 42' : 'US 10',
  'UK 16 EU 44' : 'US 12',
  'UK 18 EU 46' : 'US 14',
  'UK 6' : 'US 2',
  'UK 8' : 'US 4',
  'UK 10' : 'US 6',
  'UK 12' : 'US 8',
  'UK 14' : 'US 10',
  'UK 16' : 'US 12',
  'UK 18' : 'US 14',
};

let mens_size_map = {
  'UK 6 EU 40': 'US 7',
  'UK 7 EU 41': 'US 8',
  'UK 8 EU 42': 'US 9',
  'UK 9 EU 43': 'US 10',
  'UK 10 EU 44': 'US 11',
  'UK 11 EU 45': 'US 12',
  'UK 12 EU 46': 'US 13',
  'UK 13 EU 47': 'US 14',
  'UK 14 EU 48': 'US 15',
};

document.addEventListener('keydown', function(e) {
  if(e.key == 'Tab') {
    document.querySelector('body').classList.remove('no-outlines');
  }
});

document.querySelectorAll('.js-group').forEach(item => {
  item.addEventListener('mouseover', event => {

    let target = findParent(event, '.js-group');

    clearTimeout(closeMenuTimeout);
    clearTimeout(changeMenuTimeout);

    // If we have an active menu, allow a grace period in case mouse grazes over it when intent is to get mouse into submenu
    if(menuActive) {
      nextMenu = item;
      changeMenuTimeout = setTimeout(() => {
        // set classes to activate menu
        if(currentActiveMenu != target) {
          currentActiveMenu.querySelector('.js-submenu').classList.add('hidden');
          target.querySelector('.js-submenu').classList.remove('hidden');
          currentActiveMenu = target;
        }
      }, 150);
    } else {
      // New mouseover, so open straight away
      target.querySelector('.js-submenu').classList.remove('hidden');
      menuActive = true;
      currentActiveMenu = target;
    }

    // Set siblings so we can grey them out
    document.querySelectorAll('.js-desktop-nav-heading').forEach(item => {
        item.classList.add('opacity-50');
    });

    target.querySelector('.js-desktop-nav-heading').classList.remove('opacity-50');
  })

  // Add a grace period for exiting menu. Has to be longer than the switch menu
  item.addEventListener('mouseout', event => {
    closeMenuTimeout = setTimeout(() => {
      menuActive = false;
      if(currentActiveMenu) {
        currentActiveMenu.querySelector('.js-submenu').classList.add('hidden');
      }
      document.querySelectorAll('.js-desktop-nav-heading').forEach(item => {
        item.classList.remove('opacity-50');
    });
    }, 300);
  });

  // Keyboard accessbility
  item.querySelector('a').addEventListener("click",  function(event){

    let menu = findParent(event, '.js-group');
    let submenu = menu.querySelector('.js-submenu');
    submenu.classList.toggle('hidden');

    // Set all other menus to hidden
    document.querySelectorAll('.js-submenu').forEach(item => {
      if(item != submenu) {
        item.classList.add('hidden');
      }
    });

    event.preventDefault();
	});
});

function findParent(event, parentClass) {
  let target = null;

  // Get the js-group item by traversing through parents (the event target will be the child mouseover html element rather than the element with the trigger)
  for (target = event.target; target && target != this; target = target.parentNode) {
    if (target.matches(parentClass)) {
        break;
    }
  }

  return target;
}

/**
 * Change desktop header height on scroll
 */

let lastY = window.scrollY;

document.addEventListener("scroll", function(e) {
  let scrollThreshold;

  // Check screen width to define scroll threshold for desktop and mobile
  if (window.innerWidth <= 768) { // Example: Mobile devices (you can adjust the width)
    scrollThreshold = 38; // Mobile scroll threshold
  } else {
    scrollThreshold = 100; // Desktop scroll threshold
  }

  // Add or remove the class based on the scroll position
  if (window.scrollY >= scrollThreshold) {
    document.body.classList.add('body-scrolled');
  } else {
    document.body.classList.remove('body-scrolled');
  }
}, {passive: true});

/**
 * Mobile menu
 */
let mobileMenuToggle = document.querySelector('.js-mobile-menu-toggle');
let mobileToggleIcons = mobileMenuToggle.querySelectorAll('svg');
let mobileMenu = document.querySelector('.js-mobile-menu');
let mobileSearch = document.querySelector('.js-search');

mobileMenuToggle.addEventListener("click",  function(event) {
  mobileToggleIcons.forEach(el => {
    el.classList.toggle('hidden');
  });
  if(mobileMenu.classList.contains('hidden')) {
    mobileMenu.classList.toggle('hidden');
    setTimeout(() => {
      mobileMenu.classList.toggle('translate-x-[-120vw]')
    }, 50);
  } else {
    mobileMenu.classList.toggle('translate-x-[-120vw]')
    setTimeout(() => {
      mobileMenu.classList.toggle('hidden');
    }, 300);
  }
  mobileSearch.classList.toggle('hidden');
  document.body.classList.toggle('overflow-hidden');
  window.dispatchEvent(new CustomEvent('close-search'));

  event.preventDefault();
});

// When search is togged with mobile menu open, need to force it to open and close mobile menu
window.addEventListener('toggle-search', function(e) {
  if(!mobileMenu.classList.contains('hidden')) {
    mobileMenuToggle.click();
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('force-mobile-search'));
    }, 300);
  }
});

function toggleBodyScroll(removeBodyScroll) {
  if(removeBodyScroll) {
    document.body.classList.add('overflow-hidden');
    document.body.classList.remove('lg:overflow-auto');
  } else {
    document.body.classList.remove('overflow-hidden');
    document.body.classList.add('lg:overflow-auto');
  }
}

/*
 * Translate footwear sizes
 */
function translateRawSizeLabels() {
  let sizes = document.querySelectorAll('[data-raw-size]');

  sizes.forEach(sizeNode => {
    let label = sizeNode.dataset.rawSize;
    let newLabel = translateSize(label, sizeNode.dataset.gender);

    if(newLabel != label) {
      sizeNode.textContent = newLabel;
    }
  })
}

translateRawSizeLabels();

function translateSize(rawSize, gender) {
  let parts = rawSize.split(' ');

  if(parts[0] != 'UK' || parts.length <= 2) {
    return rawSize;
  }

  if(Shopify.currency.active == 'GBP' && parts[2] == 'EU') {
    return parts[0] + ' ' + parts[1];
  }

  if(Shopify.currency.active == 'EUR' && parts[2] == 'EU') {
    return parts[2] + ' ' + parts[3];
  }

  if(Shopify.currency.active == 'USD' || Shopify.currency.active == 'CAD') {
    if(gender == 'collection') {
      return womens_size_map[rawSize] ? womens_size_map[rawSize] : (mens_size_map[rawSize] ? mens_size_map[rawSize] : rawSize);
    }
    if(gender == 'womens') {
      return womens_size_map[rawSize] ? womens_size_map[rawSize] : rawSize;
    }

    return mens_size_map[rawSize] ? mens_size_map[rawSize] : rawSize;
  }

  return rawSize;
}

document.addEventListener('alpine:init', () => {
  /**
   * Push cart item
   */
  Alpine.data('pushCartItem', (key, quantity) => ({
    key: key,
    disabled: false,
    quantityMessageBold: false,
    quantity: quantity,

    flashQuantityMessage() {
      this.$data.quantityMessageBold = true;
      setTimeout(() => {
        this.$data.quantityMessageBold = false;
      }, 500);
    },

    change: function(formData, onComplete) {
      this.disabled = true;
      Alpine.store('cart').change(formData, onComplete ? onComplete : () => this.disabled = false);
    },

    setQuantity: function(qty) {
      this.change({
        'id': this.key,
        'quantity': qty,
        'sections': 'push-cart,cart-count'
      });
    },

  }));

  Alpine.data('cartGiftWrap', (key, name, message, variant) => ({
    locked: false,
    key: key,
    variant: variant,
    name: name,
    message: message,
    errorMessage: '',
    addGiftWrap() {
      if(this.$root.querySelectorAll('.js-giftwrap-checkbox:checked').length == 0) {
        return this.setError('At least one item needs to be checked for giftwrap');
      }

      if(!this.name) {
        return this.setError('Please fill in a name in the "To:" box above');
      }

      this.locked = true;

      if(this.key) {
        Alpine.store('cart').change({
          'sections': 'push-cart',
          'id': this.key,
          'properties': {
            "GM To": this.name,
            "GM": this.message
          },
        }, () => {
          Alpine.store('cart').mode = 'cart';
          this.locked = false;
        });
      } else {
        Alpine.store('cart').addVariant(this.variant, () => {
          Alpine.store('cart').mode = 'cart'
        }, {
          "GM To": this.name,
          "GM": this.message
        });
      }
    },
    toggleItemGiftwrap(index, current) {
      this.locked = true;
      Alpine.store('cart').change({
        'sections': 'push-cart',
        'line': index,
        'properties': {
          '_wrapped': current == 'true' ? 'false' : 'true'
        },
      }, () => {
        this.locked = false;
      });
    },
    setError(message) {
      this.errorMessage = message;
      setTimeout(() => this.errorMessage = '', 3000);
    }
  }));

  /**
   * Carousel, with filter option
   */
  Alpine.data('carousel', (loaded = true, tab = '') => ({
    tag: '',
    tab: tab,
    leftActive: false,
    loaded: loaded,
    rightActive: true,
    asyncItems: [],
    empty: false,
    percentageScroll: 0,

    init() {
      this.updateArrows();
    },

    scroll(direction) {
      let width = this.$refs.slider.offsetWidth;
      let currentPosition = this.$refs.slider.scrollLeft;
      this.$refs.slider.scrollTo({ left: direction == 'left' ? currentPosition - width : currentPosition + width, behavior: 'smooth' });
    },

    updateArrows() {
      const el = this.getActiveSlider();
      if(!el){
        this.leftActive=false;
        this.rightActive=false;
        return;
      }

      const max = Math.max(0, (el.scrollWidth || 0) - (el.clientWidth || 0));
      const x = el.scrollLeft || 0;
      this.leftActive  = x > 0;
      this.rightActive = x < (max - 1);
    },

    filter(tag) {
      if(this.$data.tag == tag) {
        return;
      }

      this.$data.tag = tag;
      this.$refs.slider.querySelectorAll('[data-tags]').forEach(el => {
        el.classList.remove('hidden');
        let tags = JSON.parse(el.dataset.tags);
        if(tags.indexOf(tag) != -1 || tag == '') {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      });

      this.$refs.slider.scrollTo({ left: 0, behavior: 'smooth' });
    },

    load(url, parser) {
      fetch(url)
        .then(response => { return response.json();})
        .then(response => {
          this.$data.asyncItems = parser(response).filter(p => p);
          this.$data.loaded = true;
          if(this.$data.asyncItems.length == 0) {
            this.$data.empty = true;
          }
        });
    },
    scrollTo(scrollPercentage) {
      this.$refs.slider.scrollTo({ left: scrollPercentage * this.$refs.slider.scrollWidth, behavior: 'smooth' });
    },

    /**
     * Multi tab slider functions
     **/

    // When tab is set, use that
    getActiveSlider(){
      return this.tab ? document.getElementById(this.tab + '-slider') : this.$refs.slider;
    },

    scrollActive(dir){
      const el = this.getActiveSlider();
      if(!el) return;
      const step = Math.round(el.clientWidth * 0.9); // near-viewport step
      el.scrollBy({ left: dir === 'right' ? step : -step, behavior: 'smooth' });
      setTimeout(() => this.updateArrows(), 150);
    },

  }));

  Alpine.data('mobileSizeGrid', () => ({
    quickAddToBag: false,
    added: false,
    variantId: '',
    addButtonText: 'Add to bag',
    loading: false,
    qtyInStock: null,
    addSingleButtonText: 'Add to bag',
    add() {
      if (!this.variantId || this.qtyInStock === 0) return;
      this.addVariant(this.variantId);
    },
    addVariant(id) {
      Alpine.store('cart').addVariant(id, () => {
        this.added = true;
        setTimeout(() => {
          this.added = false;
          this.$dispatch('close-popup-add');
        }, 1000);
      }, null, null, 'quick');
    }
  }))

  /**
   * Popup for mobile quick add
   */
  Alpine.data('popupAdd', (loaded = true) => ({
    open: false,
    loaded: false,
    init() {
      this.$watch('open', (v) => {
        if(v) {
          document.body.classList.add('overflow-hidden', 'lg:overflow-auto');
        } else {
          document.body.classList.remove('overflow-hidden', 'lg:overflow-auto');
          this.loaded = false;
        }
      })
    },
    reveal($event) {
      let handle = $event.detail.handle;
      this.open = true;
      fetch(window.Shopify.routes.root + 'products/'+handle+'?view=mobile-quick-add').then(res => {
        return res.text();
      }).then(res => {
        this.$refs.content.innerHTML = res;
        this.$nextTick(() => this.loaded = true);
      });
    }
  }));

  /**
   * Lazy carousel - wrapper around carousel with fetch collection
   */
   Alpine.data('lazyCarousel', (handle) => ({
    lazyMarkup: '',
    lazyLoaded: false,
    handle: handle,
    load() {
      fetch('/collections/' + this.handle + '?view=carousel&limit=20')
        .then(response => response.text())
        .then(text => {
          this.$data.lazyMarkup = new DOMParser().parseFromString(text, 'text/html').getElementById('carousel-content').innerHTML;
          this.$data.lazyLoaded = true;
        });
    }
  }));

  /**
   * Tassel upsell - global as included in push cart
   */
  Alpine.data('tasselUpsell', (tasselImage) => ({
    selected: '',
    adding: false,
    price: '',
    tasselImage: tasselImage,
    add() {
      this.$data.adding = true;
      Alpine.store('cart').addVariant(this.selected, () => {
        this.$data.adding = false;
      });
    }
  }));

  /**
   * Alibi in push cart
   */
  Alpine.data('alibi', (id = '') => ({
    open: false,
    alibi: '',
    id: id,
    init() {
      this.$watch('open', () => {
        document.querySelectorAll('.js-alibi-toggle').forEach(node => {
          node.classList.toggle('hidden');
        })
      });
    },
    save() {
      if (this.alibi == 'gift') {
        Alpine.store('cart').addVariant(39337899884616)
      }

      if (this.alibi == 'comp') {
        Alpine.store('cart').addVariant(39429425266760)
      }
    },
    remove() {
      Alpine.store('cart').change({
        'id': this.id,
        'quantity': 0,
        'sections': 'push-cart,cart-count'
      });
    }
  }));

  /**
   * Add discount via push cart
   */
  Alpine.data('pushDiscounts', (codes, open) => ({
    codes: codes,
    open: open,
    locked: false,
    codeToAdd: '',
    error: '',

    setError(msg, timeout) {
      this.error = msg;
      setTimeout(() => this.error = '', timeout ?? 1500);
    },

    applyNew() {
      if(!this.codeToAdd) {
        this.setError('Discount code empty');
        return;
      }
      let newCodes = [...this.codes, this.codeToAdd];
      this.updateDiscount(newCodes.join(','));
    },

    removeDiscount(code) {
      let newCodes = this.codes.filter(c => c !== code);
      this.updateDiscount(newCodes.join(','));
    },

    updateDiscount(codes) {

      this.locked = true;

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: 'discount=' + codes + '&sections=push-cart,cart-count'
      })
        .then(response => { return response.json();})
        .then(response => {

          this.locked = false;

          if (response.status) {
            alert(response.status);
            return;
          }

          if(this.codeToAdd) {
            let added = response.discount_codes.filter(c => c.code === this.codeToAdd);
            if(added.length && !added[0].applicable) {
              this.setError("Failed to add code '" + this.codeToAdd + "'", 3000);
              return;
            }
          }

          refreshCartMarkup(response.sections);
        });
    }
  }));


    Alpine.store('profile', {
    birthday: '',
    sms_sub: false,
    appLoggedIn: false,
    emailSub: false,
    showProgress: true,

    init(data = {}) {
      this.birthday = data.birthday || '';
      this.sms_sub = !!data.sms_sub;
      this.appLoggedIn = !!data.appLoggedIn;
      this.emailSub = !!data.emailSub;
      this.showProgress = !!data.showProgress;
    }
  });

  Alpine.data('search', (section_id) => ({
    init() {
      onTagalysReady(() => this.startTagalys());
    },

    section_id: section_id,
    show: false, // Used on search focus
    searched: false, // Used to swap between a search and the on focus suggestions
    term: '',
    results: {
      products: { hits: [], total: 0 },
      suggestions: { hits: [] },
      pages: { hits: [] },
      collections: { hits: [] },
    },
    desktopTab: 'products',
    searchResultsInstance: null,
    searchSuggestions: null,

    startTagalys() {
      // Used for full page search
      this.searchResultsInstance = Tagalys.APIConnector.SearchResults.new({
        onSuccess: (response, helpers) => {
          // Called after a successful API call
          console.log("*Search Results*");
          console.log("API Response: ", response);
          // Use response to render the results
        },
      });

      // Instant search
      this.searchSuggestions = Tagalys.APIConnector.SearchSuggestions.new({
        params: {
          request: {
            searches: { limit: 6 },
            products: { limit: 12 },
            collections: { limit: 4 },
            pages: { limit: 4 },
          }
        },
        onSuccess: (response, helpers) => {
          // Called after a successful API call
          this.searched = true;
          this.results = {
            products: { total: response.metadata.products.total, hits: response.products },
            suggestions: { hits: response.queries.find(q => q.section_id == 'searches')?.items || [] },
            pages: { hits: response.queries.find(q => q.section_id == 'pages')?.items || [] },
            collections: { hits: response.queries.find(q => q.section_id == 'collections')?.items || [] },
          }

          let idList = this.results.products.hits.map(p => 'id:' + p.id).join(' OR ');

          // Call for shopify search section
          if(idList) {
            sectionReplace(window.Shopify.routes.root + 'search?q=' + idList + '&section_id=' + this.section_id, 'instant-product-results', 'remote-instant-search');
          }
        },
        onFailure: (response, helpers) => {
          // Called after a API call is failed
        },
      });

      this.$watch('term', () => {
        console.log("TERM");
        if(this.$data.term == '') {
          this.$data.searched = false;
        } else {
          this.search();
        }
      });
    },

    search() {
      this.searchSuggestions.helpers.updateQuery(this.term);
    },

    getMeta(metadata, namespace, key, formatter) {
      if(metadata[namespace] && metadata[namespace][key]) {

        if(formatter) {
          return formatter(metadata[namespace][key].value);
        }

        return metadata[namespace][key].value;
      }

      console.log('Missing / blank meta: ', namespace, key);

      return '';
    }
  }));

  /*
    * Delievery countdown: used in push cart and on product details
    */
  Alpine.data('countdown', () => {
    return {
      init() {
        setInterval(() => this.tick(), 60000);
        this.tick();
      },
      tick() {
        let now = new Date(),
            cutoff = new Date(),
            arrival = new Date(),
            days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            hasGiftwrap = false,
            hourCutoff = 16,
            wantIt = '';

        // @TODO: For gift wrap orders, travel forwards 2 days, and subtract 48 hours off the order by time
        if(hasGiftwrap) {
            now.setDate(now.getDate() + 2);
        }

        let dow = now.getDay();

        // If we are past 2pm (or saturday / sunday), then arrival (at best) is not tomorrow, but next day
        if(now.getHours() >= hourCutoff || dow == 0 || dow == 6) {
            // After 2pm on a friday - delivery is tuesday (4 days away)
            if(dow == 5) {
                extraDay = 2;
            } else {
                extraDay = dow == 6 ? 1 : 0; // sat needs an extra day
            }

            if(dow == 4) {
                this.showSaturday = true;
            }

            arrival.setDate(now.getDate() + 2 + extraDay);
            cutoff.setDate(now.getDate() + 1 + extraDay);
            cutoff.setHours(hourCutoff);
            cutoff.setMinutes(0);
            cutoff.setSeconds(0);
        } else {
          if(dow == 5) {
              this.showSaturday = true;
          }
          arrival.setDate(now.getDate() + 1);
          cutoff.setDate(now.getDate());
          cutoff.setHours(hourCutoff);
          cutoff.setMinutes(0);
          cutoff.setSeconds(0);
        }

        diff = ((cutoff.getTime() - now.getTime()) / 1000);
        wantIt = cutoff.getDate() == now.getDate() ? 'tomorrow' : days[arrival.getDay()];
        days = parseInt(Math.floor(diff / 86400));
        hours = parseInt(Math.floor(diff / 3600)  % 24);
        mins = ('0' + parseInt(Math.floor((diff % 3600) / 60))).substr(-2);
        seconds = ('0' + parseInt(diff % 60)).substr(-2);

        days = days > 0 ? days + ' days ' : '';

        if(hasGiftwrap) {
            hours = hours - 48;
        }

        this.days = '' + wantIt;
        this.text = 'Order within ' + days + hours + ' hrs ' + mins + ' mins';

      },
      days: '',
      text: '',
      showSaturday: false
    }
  });

  Alpine.data('simpleCountdown', (targetDate, showSeconds) => {
    return {
      targetDate: targetDate,
      showSeconds: showSeconds,
      init() {
        setInterval(() => this.tick(), 1000);
        this.tick();
      },
      tick() {
        let now = new Date(),
            cutoff = new Date(this.targetDate),
            diff = ((cutoff.getTime() - now.getTime()) / 1000);

        days = parseInt(Math.floor(diff / 86400));
        hours = parseInt(Math.floor(diff / 3600) % 24);
        total_hours = parseInt(Math.floor(diff / 3600));
        mins = ('0' + parseInt(Math.floor((diff % 3600) / 60))).substr(-2);
        total_mins = parseInt(Math.floor((diff / 60)));
        seconds = ('0' + parseInt(diff % 60)).substr(-2);

        if(this.showSeconds) {
          this.text = total_mins + ' mins ' + seconds + ' sec';
        } else {
          this.text = days + ' days ' + hours + ' hrs ' + mins + ' mins';
        }
      },
      text: ''
    }
  });

    Alpine.data('secondCountdown', (targetDate, showSeconds) => {
    return {
      targetDate: targetDate,
      showSeconds: showSeconds,
      init() {
        setInterval(() => this.tick(), 1000);
        this.tick();
      },
      tick() {
        let now = new Date(),
            cutoff = new Date(this.targetDate),
            diff = ((cutoff.getTime() - now.getTime()) / 1000);

        days = parseInt(Math.floor(diff / 86400));
        hours = parseInt(Math.floor(diff / 3600) % 24);
        total_hours = parseInt(Math.floor(diff / 3600));
        mins = ('0' + parseInt(Math.floor((diff % 3600) / 60))).substr(-2);
        total_mins = parseInt(Math.floor((diff / 60)));
        seconds = ('0' + parseInt(diff % 60)).substr(-2);

        if(this.showSeconds) {
          this.text = total_mins + ' mins ' + seconds + ' sec';
        } else {
          this.text = hours + ' hrs ' + mins + ' mins ' + seconds + ' sec';
        }
      },
      text: ''
    }
  });

  Alpine.data('simpleMilli', () => {
    return {
      init() {
        setInterval(() => this.tick(), 100);
        this.tick();
      },
      tick() {
        this.text = ('0' + (100 - parseInt(new Date().getMilliseconds() / 10))).substr(-2) + ' ';
      },
      text: ''
    }
  });

  /*
   * App check
   */
  Alpine.store('appView', {
    isApp: false,
    init() {
      const params = new URLSearchParams(window.location.search);
      const salesChannel = params.get('sales_channel');
      if (salesChannel === 'venn_apps') {
        sessionStorage.setItem('isApp', 'true');
      }
      const fromStorage = sessionStorage.getItem('isApp');
      this.isApp = fromStorage === 'true';

      console.log('[appView:init] isApp =', this.isApp);

      if(this.isApp) {
        document.getElementById('MainContent').style.paddingTop = '0px';
      }
    },
  });

  /*
   * Wishlist store
   */
  Alpine.store('wishlist', {
		products: storedWishlist,
		handles: [],

    init() {
			this.handles = Object.keys(this.products);

      if(typeof forceWishlistResync !== 'undefined' && forceWishlistResync) {
        console.log("Resync wishlist");
        this.persist();
      }

      if(this.handles.length) {
        document.querySelector('.js-wishlist-count').innerText = this.handles.length;
        document.querySelector('.js-wishlist-count').classList.remove('hidden');
      }
    },

		toggle: function (handle, variantId = 0) {
			if (this.hasProduct(handle)) {
				delete this.products[handle];
				this.handles.splice(this.handles.indexOf(handle), 1);
			} else {
				this.products[handle] = variantId;
				this.handles.push(handle);
			}

			localStorage.setItem('faf-wish-list', JSON.stringify(this.products))
			this.persist();
		},
		hasProduct: function (handle) {
			return this.handles.indexOf(handle) > -1;
		},
		persist() {
			if (typeof customerId !== 'undefined') {
        fetch('https://fafv2.trsdesign.com/api/wishlist', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ wishlist: this.products, customerId: customerId })
        })
			}
		}
  });

  /**
   * App view + DG loader
   * Note - config for DG set in zen.liquid, and will not load on app
   */
  Alpine.store('appView', {
    isApp: false,
    dgLoaded: false, // 💡 add a flag to ensure it's not run twice

    init() {
      const params = new URLSearchParams(window.location.search);
      this.isApp = params.get('sales_channel') === 'venn_apps';

      if (!this.isApp && !this.dgLoaded) {
        this.dgLoaded = true;

        const dgScript = document.createElement('script');
        dgScript.src = 'https://chat.digitalgenius.com/init.js';
        dgScript.onload = () => {
          if (window.dgchat && !window.dgchat.initialized) {
            window.dgchat.init();
            window.dgchat.initialized = true; // also double-protect at global level
          }
        };
        document.head.appendChild(dgScript);
      }
    }
  });


  Alpine.data('confidenceBuilder', (slideCount) => ({
    currentSlide: 0,
    slideCount: slideCount,
    interval: '',
    init() {
      this.$data.createInterval();
    },
    createInterval() {
      this.$data.interval = setInterval(() => {
        this.setSlide(this.$data.currentSlide + 1);
      }, 5000);
    },
    setSlide(index, resetInterval = false) {
      this.$data.currentSlide = index % this.$data.slideCount;
      if(resetInterval) {
        this.$data.resetInterval();
      }
    },
    resetInterval() {
      clearInterval(this.$data.interval);
      this.$data.createInterval();
    }
  }));


  Alpine.data('gifImage', (slideCount) => ({
    currentSlide: 0,
    slideCount: slideCount,
    interval: '',
    init() {
      this.$data.createInterval();
    },
    createInterval() {
      this.$data.interval = setInterval(() => {
        this.setSlide(this.$data.currentSlide + 1);
      }, 2000);
    },
    setSlide(index, resetInterval = false) {
      this.$data.currentSlide = index % this.$data.slideCount;
      if(resetInterval) {
        this.$data.resetInterval();
      }
    },
    resetInterval() {
      clearInterval(this.$data.interval);
      this.$data.createInterval();
    }
  }));

  Alpine.data('productSync', (updates) => ({
    updates: updates,
    init() {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: this.updates + '&sections=push-cart,cart-count'
      })
        .then(response => { return response.json();})
        .then(response => {
          if (response.status) {
            alert(response.status);
            return;
          }

          refreshCartMarkup(response.sections);
        });
    }
  }));

  Alpine.data('newsletter', (endpoint) => ({
    endpoint: endpoint,
    error: '',
    sent: false,
    submit() {
      if(!this.$refs.newsletterForm.reportValidity()) {
        return;
      }

      let formData = new FormData(this.$refs.newsletterForm);
      let formPostData = new URLSearchParams(formData).toString();

      fetch(this.endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: formPostData
      })
        .then(response => { return response.json();})
        .then(response => {
          this.sent = true;
        }).catch((error) => {
          this.error = error;
          setTimeout(() => this.error = '', 5000);
        });

    }
  }));

  Alpine.data('shareModal', (title,description, url, context) => ({
    open: false,
    context: context,
    launch: function(url) {

      // Some shares append dynamic values
      if(url) {
        this.url = url;
      }

      if(navigator && navigator.share && ('ontouchstart' in window || navigator.msMaxTouchPoints)) {
        navigator.share({ title: this.title, 'text': this.url });
      } else {
        this.open = true;
      }
    },
    title: title,
    description: description,
    url: url,
    urls: {
      facebook: 'https://www.facebook.com/sharer/sharer.php?u=[URL]&title=[TITLE]&description=[DESCRIPTION]',
      twitter: 'https://twitter.com/intent/tweet?text=[DESCRIPTION] [URL]',
      mail: 'mailto:?body=[URL]&subject=[DESCRIPTION]',
      pinterest: 'https://pinterest.com/pin/create/bookmarklet/?url=[URL]&description=[DESCRIPTION]',
      whatsapp: 'https://api.whatsapp.com/send?text=[DESCRIPTION] [URL]'
    },
    shareUrl: function(url) {
      return url.replace('[DESCRIPTION]', this.description)
        .replace('[TITLE]', this.title)
        .replace('[URL]', this.url)
    },
    track(method) {
      if(gtag && this.context) {
        gtag('event', 'shared', { method: method, context: this.context });
        console.log(method);
      }
    },
    copy: function() {
      var copyUrl = this.$refs.copyUrl;
      copyUrl.focus();
      copyUrl.select();
      document.execCommand('copy');
      this.track('manual copy');
    }
  }));

  Alpine.data('quickAddToBag', () => ({
    init() {
      this.$watch('variantId', (v) => {
        if(v) {
          this.addButtonText = 'Add to bag';
        } else {
          this.addButtonText = 'Select Size';
        }
      })
    },
    variantId: '',
    showMobile: false,
    addButtonText: 'Select Size',
    addSingleButtonText: 'Add to bag',
    add() {
      if(this.variantId == '') {
        this.showMobile = !this.showMobile;
      } else {
        this.addButtonText = 'Adding...';
        Alpine.store('cart').addVariant(this.variantId, () => {
          this.showMobile = false;
          this.variantId = '';
        });
      }
    },

    addVariant(id) {
      this.addSingleButtonText = 'Adding...';
      Alpine.store('cart').addVariant(id, () => {
        this.showMobile = false;
        this.addSingleButtonText = 'Add to bag';
      });
    }
  }));

  Alpine.data('quickAddAlt', () => ({
    quickAddToBag: false,
    variantId: '',
    loading: false,
    adding: false,
    added: false,
    add(variantId) {
      this.loading = true;
      this.adding = true;
      this.variantId = variantId;
      Alpine.store('cart').addVariant(variantId, () => {
        this.loading = false;
        this.adding = false;
        this.added = true;
        setTimeout(() => {
          this.added = false;
          this.variantId = ''
        }, 2000);
      }, null, null, 'quick');
    },
    variantClass(variantId) {
      if(this.variantId == variantId) {
        if(this.adding) {
          return 'bg-sg-navy text-white opacity-60 cursor-wait';
        }
        if(this.added) {
          return 'bg-sg-gold text-white';
        }
      }

      return 'text-sg-navy hover:bg-sg-navy hover:text-white';
    }
  }));

  /*
   * Freee gift choice popup
   */
  Alpine.data('offerPopup', () => ({
    showOffer: true,
    setOptOut() {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          'attributes': {
            'opt_out_keyring': 1
          }
        })
      })
    }
  }));

  Alpine.data('simpleDotScroller', (slideCount) => ({
    scrollPercent: 0,
    dotIndex: 1,
    slideCount: slideCount,
    updateDots() {
      this.$data.scrollPercent = this.$refs.slider.scrollLeft / this.$refs.slider.scrollWidth;
      this.$data.dotIndex = Math.round(this.$data.scrollPercent * this.$data.slideCount) + 1;
    },
    scrollTo(index) {
      this.$refs.slider.scrollTo({ left: ((index - 1) / this.slideCount) * this.$refs.slider.scrollWidth, behavior: 'smooth' });
    }
  }));

  Alpine.data('wishlistOpener', () => ({
    open() {
      var start = Date.now();
      var timeout;

      window.location = 'fairfaxandfavor://wishlist';

      timeout = setTimeout(function () {
        if (Date.now() - start < 3000) {
          window.location.href = 'https://apps.apple.com/gb/app/fairfax-and-favor-2/id6743029857';
        }
      }, 2000);
    }
  }));

  /*
   * Browse abandon
   */
  Alpine.data('browseAbandonBanner', (variantIdsString) => ({
    open: false,
    adding: false,
    variantsToAdd: variantIdsString ? variantIdsString.split(',').map((id) => parseInt(id, 10)) : [],

    WEEK_MS: 7 * 24 * 60 * 60 * 1000,

    init() {
      const closed = this.getClosedFlag();
      if (closed) return;

      // Delay show
      setTimeout(() => {
        this.open = true;
      }, 4000);
    },

    getClosedFlag() {
      const raw = localStorage.getItem('browse_abandon_closed');
      if (!raw) return false;

      try {
        const data = JSON.parse(raw);
        if (!data.expires || Date.now() > data.expires) {
          localStorage.removeItem('browse_abandon_closed');
          return false;
        }
        return data.value === true;
      } catch (e) {
        localStorage.removeItem('browse_abandon_closed');
        return false;
      }
    },

    setClosedFlag() {
      localStorage.setItem(
        'browse_abandon_closed',
        JSON.stringify({
          value: true,
          expires: Date.now() + this.WEEK_MS,
        })
      );
    },

    close() {
      this.open = false;
      this.setClosedFlag();
    },

    goToCartDrawer() {
      Alpine.store('lazyPanel').openPanel('push-cart');
      this.close();
    },

    async addMissingItemsAndOpenCart() {
      if (!this.variantsToAdd.length) {
        this.goToCartDrawer();
        return;
      }

      this.adding = true;

      // Don't use store here, as we don't want to fetch push-cart section
      const addOne = (id) => {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ id, quantity: 1 }),
        }).catch(() => {});
      };

      for (const id of this.variantsToAdd) {
        await addOne(id);
      }

      this.adding = false;
      this.goToCartDrawer();
    },
  }));

  Alpine.data('accountPanel', () => ({
    activeTab: '',
    init() {
      const urlParams = new URLSearchParams(window.location.search);
      const tabFromUrl = urlParams.get('tab');
      if (tabFromUrl) {
        this.activeTab = tabFromUrl;
        setTimeout(() => { this.$store.lazyPanel.openPanel('push-account'); }, 50); // delay to allow transitions
      }
    },
    switchTab(tab) {
      this.activeTab = tab;
      window.dispatchEvent(new CustomEvent('account-tab:open', { detail: { tab } }))
    }
  }));

  /**
   * Customer form - handles customer details update
   */
Alpine.data('customerForm', (config) => ({
  // --- guard ---
  _inited: false,
  _geoLoaded: false,
  _phoneLibPromise: null,

  // --- view / behaviour control ---
  context: config.context || 'account',
  view: config.view || 'form',
  loading: false,

  firstName: config.firstName || '',
  lastName: config.lastName || '',
  phone: config.phone || '',
  store: config.store || '',
  customerPhone: config.customerPhone || '',
  email: config.email || '',
  subscribeMarketing: config.subscribeMarketing === true || config.subscribeMarketing === 'true',
  subscribeSMSMarketing: config.subscribeSMSMarketing === true || config.subscribeSMSMarketing === 'true',
  birthday: config.birthday || '',
  birthdayDay: '',
  birthdayMonth: '',
  declinePlatinum: config.declinePlatinum || '',
  address1: config.address1 || '',
  address2: config.address2 || '',
  city: config.city || '',
  country: config.country || '',
  zip: config.zip || '',
  feedbackForm: config.feedbackForm || '',
  clubPage: config.clubPage === true || config.clubPage === 'true',
  appLoggedIn: config.appLoggedIn === true || config.appLoggedIn === 'true',
  error: '',
  submitted: false,
  showSaved: false,
  optOut: config.optOut === true || config.optOut === 'true',
  optOutConfirmed: config.optOutConfirmed === true || config.optOutConfirmed === 'true',
  countryCode: config.countryCode || '',
  addressId: config.addressId || '',
  customerId: config.customerId || '',
  token: config.token || '',
  countryCodeForSubmit: config.countryCodeForSubmit || '',

  monthNames: [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ],

  async initOnce() {
    if (this._inited) return;
    this._inited = true;

    if (this.birthday && this.birthday.includes('-')) {
      const [month, day] = this.birthday.split('-');
      this.birthdayMonth = month;
      this.birthdayDay = day;

      if (this.birthday === localStorage.getItem('pendingBirthday')) {
        localStorage.removeItem('pendingBirthday');
      }
    } else {
      const storedBirthday = localStorage.getItem('pendingBirthday');

      if (storedBirthday && storedBirthday.includes('-')) {
        this.birthday = storedBirthday;
        const [month, day] = storedBirthday.split('-');
        this.birthdayMonth = month;
        this.birthdayDay = day;
      }
    }

    await this.loadGeoCountryOnce();
  },

  async loadGeoCountryOnce() {
    if (this._geoLoaded) return;
    this._geoLoaded = true;

    try {
      const res = await fetch('https://ipapi.co/json/', { cache: 'no-store' });
      const data = await res.json();

      if (data && data.country) {
        this.countryCode = data.country;
      }
    } catch (e) {
      // keep Shopify fallback
    }
  },

  ordinal(day) {
    if ([11, 12, 13].includes(day)) return day + 'th';

    switch (day % 10) {
      case 1:
        return day + 'st';
      case 2:
        return day + 'nd';
      case 3:
        return day + 'rd';
      default:
        return day + 'th';
    }
  },

  formatBirthday(birthday) {
    if (!birthday || !birthday.includes('-')) return '';

    const [month, day] = birthday.split('-');
    const monthName = this.monthNames[parseInt(month) - 1];

    return `${monthName} ${this.ordinal(parseInt(day))}`;
  },

  loadLibPhoneNumber() {
    if (window.libphonenumber?.parsePhoneNumber) {
      return Promise.resolve(window.libphonenumber);
    }

    if (this._phoneLibPromise) {
      return this._phoneLibPromise;
    }

    this._phoneLibPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://unpkg.com/libphonenumber-js@1.10.21/bundle/libphonenumber-max.js';
      s.async = true;
      s.onload = () => resolve(window.libphonenumber);
      s.onerror = reject;
      document.head.appendChild(s);
    });

    return this._phoneLibPromise;
  },

  async isPhoneValid() {
    try {
      const lib = await this.loadLibPhoneNumber();
      const phoneNumber = lib.parsePhoneNumber(this.phone || '', this.countryCode);

      return phoneNumber.isValid();
    } catch (e) {
      return false;
    }
  },

  async submitForm() {
    this.error = '';
    this.loading = true;

    let newBirthday = '';

    const day = this.birthdayDay;
    const month = this.birthdayMonth;

    if (day && month) {
      newBirthday = month.padStart(2, '0') + '-' + day.padStart(2, '0');
    } else if (day || month) {
      this.error = 'Please select both month and day for your birthday.';
      this.loading = false;
      return;
    }

    if (!this.email || !this.email.includes('@')) {
      this.error = 'Please enter a valid email address.';
      this.loading = false;
      return;
    }

    if (this.phone && !(await this.isPhoneValid())) {
      this.error = 'Please enter a valid phone number.';
      this.loading = false;
      return;
    }

    try {
      await fetch('https://webhooks.mechanic.dev/9a9bd1ef-0f7e-4a83-8b57-e22f32d5c634', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_id: this.customerId,
          address_id: this.addressId,
          first_name: this.firstName,
          last_name: this.lastName,
          phone: this.phone,
          store: this.store,
          app_logged_in: this.appLoggedIn,
          customer_phone: this.customerPhone,
          address1: this.address1,
          address2: this.address2,
          declinePlatinum: this.declinePlatinum,
          city: this.city,
          feedback_form: this.feedbackForm,
          country: this.country,
          context: this.context,
          zip: this.zip,
          email: this.email,
          club_page: this.clubPage,
          subscribe_marketing: this.subscribeMarketing,
          subscribe_sms_marketing: this.subscribeSMSMarketing,
          opt_out: this.optOut,
          birthday: newBirthday || this.birthday || '',
          token: this.token,
          country_code: this.countryCodeForSubmit
        }),
      });

      this.submitted = true;
      this.optOutConfirmed = this.optOut;

      if (newBirthday) {
        this.birthday = newBirthday;
        localStorage.setItem('pendingBirthday', newBirthday);
      }

      Alpine.store('profile').birthday = newBirthday || this.birthday || '';
      Alpine.store('profile').sms_sub = this.subscribeSMSMarketing;
      Alpine.store('profile').emailSub = this.subscribeMarketing;

      Alpine.store('profile').showProgress =
        !(
          Alpine.store('profile').birthday &&
          Alpine.store('profile').sms_sub &&
          Alpine.store('profile').emailSub &&
          Alpine.store('profile').appLoggedIn
        );

      if (this.context === 'platinumOnboarding') {
        this.view = 'success';
      } else {
        this.showSaved = true;
        this.activeTab = '';

        setTimeout(() => {
          this.showSaved = false;
        }, 2000);
      }
    } catch (e) {
      this.error = 'Something went wrong. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}));

  /*
   * Account panel - show progress for app signup etc
   */
Alpine.data('profileProgress', () => ({
  get birthday() {
    return Alpine.store('profile').birthday;
  },
  get sms_sub() {
    return Alpine.store('profile').sms_sub;
  },
  get appLoggedIn() {
    return Alpine.store('profile').appLoggedIn;
  },
  get emailSub() {
    return Alpine.store('profile').emailSub;
  },
  get showProgress() {
    return Alpine.store('profile').showProgress;
  },
  set showProgress(value) {
    Alpine.store('profile').showProgress = value;
  },
  get hasBirthday() {
    return this.birthday !== '';
  },
  get completeCount() {
    return [
      this.hasBirthday,
      this.appLoggedIn,
      this.sms_sub,
      this.emailSub
    ].filter(Boolean).length;
  },
  get percentage() {
    return Math.round((this.completeCount / 4) * 100);
  }
}));

  /*
   * Lazy panel - used for cart and account
   */
  Alpine.store('lazyPanel', {
    init() {
      Alpine.effect(() => {
        toggleBodyScroll(this.open);
      });
    },
    width: 720,
    open: false,
    loadedPanels: [],
    activePanel: '',
    loadPanel(sectionName) {

      if(this.loadedPanels.indexOf(sectionName) > -1) {
        this.activePanel = sectionName;
        return;
      }

      this.activePanel = 'loading';
      this.loadedPanels.push(sectionName);

      fetch(window.Shopify.routes.root + '?sections=' + sectionName)
        .then(response => { return response.json();})
        .then(response => {
          this.setMarkup(sectionName, response[sectionName]);
          this.activePanel = sectionName;
        })
    },

    setMarkup(sectionName, markup) {
      document.getElementById('lazy-' + sectionName).innerHTML = new DOMParser().parseFromString(markup, 'text/html').getElementById('shopify-section-' + sectionName).innerHTML;
      if(this.loadedPanels.indexOf(sectionName) == -1) {
        this.loadedPanels.push(sectionName);
      }
    },

    openPanel(sectionName, markup) {

      this.width = sectionName == 'push-account' ? 548 : 720;
      Alpine.nextTick(() => {
        this.open = true;
      });

      if(markup) {
        this.activePanel = sectionName;
        this.setMarkup(sectionName, markup);
      } else {
        this.loadPanel(sectionName);
      }
    },

  });

  Alpine.store('cart', {
    mode: 'cart', // can be wrap
    addVariantWithDiscount(variantId, discountCode) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ discount: discountCode, attributes: { '_discount': discountCode } })
      })
      .then(response => response.json())
      .then(data => {
        Alpine.store('cart').addVariant(variantId);
      });
    },

    autoRemoveDiscount(variantId) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: { '_discount': '' } })
      })
      .then(response => response.json())
      .then(data => {
        Alpine.store('cart').change({ id: variantId, quantity: 0, sections: 'push-cart' });
      });
    },

    addVariant(variantId, onComplete, properties, extraItems, mode) {
      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }],
        'sections': 'push-cart,cart-count'
      };

      if(extraItems) {
        formData['items'].push(...extraItems);
      }

      if(properties) {
        formData['items'][0]['properties'] = properties;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => { return response.json();})
        .then(response => {
          if (response.status) {
            if(response.status == 422) {
              throw new Error('Not enough stock');
            }
            return;
          }

          Alpine.store('lazyPanel').setMarkup('push-cart', response.sections['push-cart']);
          document.querySelector('.js-cart-count').innerHTML = response.sections['cart-count'];
          document.querySelector('.js-cart-count').classList.remove('hidden');
        })
        .then(() => {

          if (mode == 'quick') {
            window.dispatchEvent(new CustomEvent('cart-added', {
              detail: { timeout: 2000 },
              bubbles: true
            }));
          } else {
            Alpine.store('lazyPanel').openPanel('push-cart');
            if(mode) {
              this.mode = mode;
            }
          }

          if(typeof item === "object" && typeof _learnq == "object") {
            _learnq.push(['track', 'Added to Cart', item]);
          }

          if(onComplete) {
            onComplete();
          }
        })
        .catch((error) => {
          if(onComplete) {
            onComplete(error);
          } else {
            alert(error);
          }
        });
    },

    change(formData, onComplete) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => { return response.json();})
        .then(response => {
          if (response.status) {
            alert(response.message ? response.message : response.status);
          }

          if(response.sections) {
            Alpine.store('lazyPanel').openPanel('push-cart', response.sections['push-cart']);
          }

          if(onComplete) {
            onComplete();
          }

        })
        .catch((error) => {
          alert(error);
        });
    }
  });

  Alpine.data('pointsCalculator', (customerId, customerEmail, qrFillColor, containerId) => ({
    qrCode: false,
    qrGenerated: false,
    toggleQRCode() {
      this.qrCode = !this.qrCode;
      if (this.qrCode && !this.qrGenerated) {
        this.$nextTick(() => {
          this.generateQR();
        });
      }
    },
    generateQR() {
      const container = document.getElementById(containerId);
      if (!container) return;
      if (typeof QRCode === 'undefined') return;

      const qrLink = `https://jeri.link/fairfax-and-favor-2/mgm?referral=${customerEmail}&customer_id=${customerId}`;
      new QRCode(container, {
        text: qrLink,
        width: 150,
        height: 150,
        colorDark: qrFillColor,
        colorLight: 'transparent',
        correctLevel: QRCode.CorrectLevel.L,
      });
      this.qrGenerated = true;
    }
  }));

  Alpine.data('pointsAnimation', () => ({
    counter: 0,
    count(finalCount) {
      const duration = 2500;
      const start = 0;
      const end = finalCount;
      const range = end - start;
      let startTime = null;

      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        this.counter = Math.floor(start + range * progress);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          this.counter = end;
        }
      };
      requestAnimationFrame(step);
    }
  }));

  Alpine.store('appInfo', {
    getUrl() {
      const ua = navigator.userAgent || navigator.vendor || window.opera;
      if (/android/i.test(ua)) {
        return window.routes.app_android;
      } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
        return window.routes.app_ios;
      }

      return window.routes.app_default;
    },
    openApp() {
      const start = Date.now();
      window.location = 'fairfaxandfavor://home';
      setTimeout(() => {
        if (Date.now() - start < 3000) {
          const ua = navigator.userAgent || navigator.vendor || window.opera;
          if (/android/i.test(ua)) {
            window.location.href = window.routes.app_android;
          } else {
            window.location.href = 'https://apps.apple.com/gb/app/fairfax-and-favor-2/id6743029857';
          }
        }
      }, 2000);
    }
  });

  Alpine.store('recent', {

    keep: 12, // How many items to keep in the list
    recentHandle: 'recently-viewed-6', // Probably shouldn't change

    getRecent(config) {
      const {
        targetMarkupId,
        view,
        remoteMarkupId = 'remote-recs',
        onComplete = null,
        limit = 8
      } = config;

      let recentlyViewed = JSON.parse(localStorage.getItem(this.recentHandle)) || [];
      let recentHandleList = recentlyViewed.filter(v => v).slice(0, limit).map(handle => 'handle:' + handle).join(' OR ');
      let recentUrl = `${window.routes.search}.json?view=${view}&q=${encodeURI(recentHandleList)}`;

      if(recentHandleList) {
        sectionReplace(recentUrl, targetMarkupId, remoteMarkupId);
        if(onComplete) {
          onComplete();
        }
      } else {
        document.getElementById(targetMarkupId).classList.add('hidden');
      }
    },

    push(handle) {
      let recentlyViewed = JSON.parse(localStorage.getItem(this.recentHandle)) || [];

      if(recentlyViewed.includes(handle)) {
        recentlyViewed.splice(recentlyViewed.indexOf(handle), 1);
      }

      recentlyViewed.unshift(handle);

      while(recentlyViewed.length > this.keep) {
        recentlyViewed.pop();
      }

      localStorage.setItem(this.recentHandle, JSON.stringify(recentlyViewed));
    }
  });

  Alpine.store('tagalysRecs', {
    getRecsForProduct(config) {
      onTagalysReady(() => {
        const {
          productId,
          targetMarkupId,
          view = 'tagalys-recs',
          remoteMarkupId = 'remote-cart-recs',
          recId = 'e3f4dab0ad3a47afc06a',
          onComplete = null,
          limit = 8,
        } = config;

        Tagalys.APIConnector.Recommendations.call({
          params: {
            recommendationId: recId,
            productId: productId,
            limit: limit
          },
          onSuccess: (response) => {
            let recsIdList = response.products.map(p => 'id:' + p.id).join(' OR ');
            let recsUrl = window.routes.search + '.json?view=' + view + '&q=' + encodeURI(recsIdList);

            if(recsIdList) {
              sectionReplace(recsUrl, targetMarkupId, remoteMarkupId);
              if(onComplete) {
                onComplete();
              }
            }

          },
          onFailure: function(response){
            // Called after a failed API call
          }
        })

      });
    }
  });

  Alpine.data('verticalRecs', (id) => ({
    id: id,
    progress: 5,
    showBar: false,
    init() {
      Alpine.store('tagalysRecs').getRecsForProduct({
        productId: this.id,
        targetMarkupId: 'cart-recs',
        onComplete: () => {
          this.$nextTick(() => {
            this.$refs.verticalSlider.addEventListener('scroll', () => this.update(), { passive: true });
            setTimeout(() => this.update(), 1000);
          });
        }
      });
    },
    update() {
      const el = this.$refs.verticalSlider;
      if (!el) return;
      const max = el.scrollHeight - el.clientHeight;
      this.showBar = max > 2; // show only if scrollable
      this.progress = this.showBar ? (el.scrollTop / max) * 100 : 0;
    }
  }));

  if(window.location.search.indexOf('cart-pop=1') != -1) {
    Alpine.store('lazyPanel').openPanel('push-cart');
  }

});

function refreshCartMarkup(sections) {
  if(sections['push-cart']) {
    document.getElementById('shopify-section-push-cart').innerHTML = new DOMParser().parseFromString(sections['push-cart'], 'text/html').getElementById('shopify-section-push-cart').innerHTML;
  }

  if(sections['cart-count']) {
    document.querySelector('.js-cart-count').innerHTML = sections['cart-count'];
  }
}



function openSizes() {

}

function getSizedImage(src, size) {
  return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function(match) {
      return '_'+size+match;
    });
}

function getImageSrcset(src, sizes) {
  return sizes.map(w => {
    return getSizedImage(src, w + 'x') + ' ' + w + 'w';
  }).join(', ');
}

function setClipboard(value) {
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = value;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
}

function onTagalysReady(callback) {
  if (window.Tagalys) {
    setTagalysConfiguration();
    setPlatformConfigurationForTagalys();
    callback();
  } else {
    window.addEventListener("DOMContentLoaded", function () {
      setTagalysConfiguration();
      setPlatformConfigurationForTagalys();
      callback();
    });
  }
}

function setTagalysConfiguration() {
  Tagalys.setConfiguration({
    api: {
      serverUrl: "https://api-r4.tagalys.com",
      credentials: {
        clientCode: "E87983FB80DC6BD2",
        apiKey: "cdb824442afeb6f9c190bcf0491265bd"
      },
      storeId: "2716001"
    },
    locale: "en-GB",
    currency: {
      displayFormatter: "{{currencyLabel}}{{value}}",
      code: "GBP",
      label: "£",
      fractionalDigits: 2,
      forceFractionalDigits: true
    },
    analyticsStorageConsentProvided: function() {
      // return true/false based on user's consent settings
      return true;
    },
    track: true
  });
}

function setPlatformConfigurationForTagalys() {
  Tagalys.setPlatformConfiguration({
    platform: "Shopify",
    metafields: {
      products: [
        {
          namespace: "prod_strings",
          key: "colour",
        },
        {
          namespace: "prod_strings",
          key: "range_title",
        },
        {
          namespace: "prod_strings",
          key: "fit",
        },
        {
          namespace: "faf",
          key: "product_style",
        },
      ],
    },
    countryCode: "GB", // replace with Shopify.country to set the shopper's chosen country
    baseCountryCode: "GB",
    useStorefrontAPIForSecondaryMarkets: true,
    waitForStorefrontAPI: true,
    storefrontAPI: {
      accessToken: "b568fff0945e995e4ab87b6f5cce6250",
      myShopifyDomain: "fairfax-and-favor-2.myshopify.com",
    },
  })
}

function sectionReplace(url, onPageTargetID, remoteTargetID) {
  fetch(url)
    .then(response => { return response.text();})
    .then(response => {
      document.getElementById(onPageTargetID).innerHTML = new DOMParser().parseFromString(response, 'text/html').getElementById(remoteTargetID).innerHTML;
    })
}

